$(document).ready(function() {
    var quickShop = {
        ...window.quickShop,
        toggleSwatchImages: function(swatchInput){
            var swatchImageID = $(swatchInput).data('image');
            var $quickShopElement = $(swatchInput).parents('.thumbnail').find('.image__container img');

            const JSONData = $('.product_form--swatches').data('product')
            
            const ID = $(swatchInput).parents('.swatch-element').data('id')


            const selected = $('select[class="multi_select"]').find('option[selected="selected"]').text()
            const index = JSONData.variants.findIndex(el => el.id == ID)
    
            const images = $('.js-product-gallery .gallery-cell img')
            let imageIDs = []
            for (const image of images) {
                imageIDs.push($(image).data('image-id'))
            }
    
            const indexImage = imageIDs.findIndex(el => el == JSONData.variants[index].featured_media.id)
            console.log({imageIDs, indexImage});
            setTimeout(() => {
                $('.js-product-gallery').flickity('select', indexImage)
            }, 200)
          }
    }
})